import { forEach as _forEach } from 'lodash';

/*
 * Private properties
 */
const APP = new WeakMap();
const customElements = new WeakMap();
const config = new WeakMap();
const plugins = new WeakMap();

/**
 * Boot Vue
 *
 * @param selector
 * @param App
 */
class VueBootstrap {
  /**
   * Main constructor
   */
  constructor() {
    config.set(this, []);
    plugins.set(this, []);
    customElements.set(this, []);
  }

  /**
   * Init main configs
   *
   * @param App
   * @returns {VueBootstrap}
   */
  init(App = null) {
    APP.set(this, App);

    this::applyConfig();
    this::applyPlugins();
    this::applyCustomElements();

    return this;
  }

  /**
   * Initialize App
   *
   * @param el
   */
  mount(el) {
    if (!el && !APP.get(this)) {
      return;
    }

    _forEach(document.querySelectorAll(el), el =>
      new Vue(APP.get(this)).$mount(el)
    );
  }

  /**
   * Append custom element to App
   *
   * @param name
   * @param component
   * @param props
   */
  addCustomElement(name, component, props = {}) {
    customElements.get(this).push({ name, component, props });

    return this;
  }

  /**
   * Add Vue config param
   *
   * @param param
   * @param value
   * @returns {VueBootstrap}
   */
  addConfigParam(param, value) {
    config.get(this).push({ param, value });

    return this;
  }

  /**
   * Add Vue plugin
   *
   * @param plugin
   * @param config
   * @returns {VueBootstrap}
   */
  attachPlugin(plugin, config = {}) {
    plugins.get(this).push({ plugin, config });

    return this;
  }

  addGlobalDirective(name, directive) {
    Vue.directive(name, directive);
  }
}

/*------------------
 | Private methods
 |------------------*/

/**
 * Configs
 */
function applyConfig() {
  config.get(this).forEach(({ param, value }) => (Vue.config[param] = value));
}

/**
 * Set Vue plugins
 */
function applyPlugins() {
  plugins.get(this).forEach(({ plugin, config }) => Vue.use(plugin, config));
}

/**
 * Apply custom elements to Vue
 */
function applyCustomElements() {
  const elements = customElements.get(this);

  if (elements.length) {
    require.ensure([], require => {
      const { default: vueCustomElement } = require('vue-custom-element');

      Vue.use(vueCustomElement);

      elements.forEach(({ name, component, props }) =>
        Vue.customElement(name, component, props)
      );
    });
  }
}

export default VueBootstrap;



// WEBPACK FOOTER //
// ./templates/floor/assets/js/Global/VueBootstrap.js